import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  addDoc, 
  deleteDoc, 
  updateDoc, 
  doc,
  orderBy,
  query,
  Timestamp
} from 'firebase/firestore';

// Your Firebase configuration (find this in Firebase Console > Project Settings)
const firebaseConfig = {
  apiKey: "AIzaSyBvbTow0zcYOi9MByJSdz8_dCn2gjcvkVM",
  authDomain: "kairalyholidays-3b623.firebaseapp.com",
  projectId: "kairalyholidays-3b623",
  storageBucket: "kairalyholidays-3b623.firebasestorage.app",
  messagingSenderId: "625719690297",
  appId: "1:625719690297:web:60ff389a62291a6a3939e8",
  measurementId: "G-G9RF8YQ9T7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Collection reference
export const packagesCollection = collection(db, 'packages');

// Helper functions
export const addPackageToDB = async (packageData) => {
  try {
    const docRef = await addDoc(packagesCollection, {
      ...packageData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error adding package: ", error);
    return { success: false, error: error.message };
  }
};

export const getPackagesFromDB = async () => {
  try {
    const q = query(packagesCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const packages = [];
    querySnapshot.forEach((doc) => {
      packages.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: packages };
  } catch (error) {
    console.error("Error getting packages: ", error);
    return { success: false, error: error.message, data: [] };
  }
};

export const deletePackageFromDB = async (packageId) => {
  try {
    await deleteDoc(doc(db, 'packages', packageId));
    return { success: true };
  } catch (error) {
    console.error("Error deleting package: ", error);
    return { success: false, error: error.message };
  }
};

export const updatePackageInDB = async (packageId, updatedData) => {
  try {
    const packageRef = doc(db, 'packages', packageId);
    await updateDoc(packageRef, {
      ...updatedData,
      updatedAt: Timestamp.now()
    });
    return { success: true };
  } catch (error) {
    console.error("Error updating package: ", error);
    return { success: false, error: error.message };
  }
};